export default "__VITE_ASSET__pWKgzX77__"